import { LOCALHOST } from '../constants/constants';

export const FRESH_HOSTS = /^https:\/\/(fresh|fresh.staging|fresh-applications|fresh-applications.staging)+.hummingbirdtech.com/gi;

const isFreshUrl = (url?: string) =>
  !!url && (url.startsWith(LOCALHOST) || url.match(FRESH_HOSTS));

export default isFreshUrl;
